export var OsdVersionsEnum;
(function (OsdVersionsEnum) {
    OsdVersionsEnum["Osd_2_0"] = "2.0.0";
    OsdVersionsEnum["Kibana_7_6"] = "7.6.1";
})(OsdVersionsEnum || (OsdVersionsEnum = {}));
//# sourceMappingURL=osd-versions.enum.js.map